/******************************************************
 *                  D BAR CHART DIRECTIVE
 *
 * This directive draws a d3 multiple bar chart given some
 * input data
 *
 * Directive usage : <tch-d3-grouped-bar-chart data="myData" [margin="xxx"] [barHeight="xxx"] [barPadding="xxx"] ></tch-d3-grouped-bar-chart>
 *
 * Input data : declare a scope variable of this kind :
 *
 *  $scope.myData = [
 *{
 *    "stopPoint": "Gare",
 *    "stats": [
 *        {
 *            "statName": "descente",
 *            "statValue": 15
 *        },
 *        {
 *            "statName": "montée",
 *            "statValue": 16
 *        }
 *    ]
 *},
 *
 *{
 *    "stopPoint": "blabla",
 *    "stats": [
 *        {
 *            "statName": "descente",
 *            "statValue": 18
 *        },
 *        {
 *            "statName": "montée",
 *            "statValue": 11
 *        }
 *    ]
 *},
 *...
 * ]
 *
 *
 * There can me as many stats type as we want, directive will handle generating correct colors and legends.
 * You don't haave to have same stats type for each data point.
 ********************************************************/

"use strict";

angular.module("app")

	.directive("tchD3GroupedBarChart", [ "$window", function ($window) {

		return {

			// restrict this directive usage to dom 'E'lements (by default restricted to 'A'ttributes
			restrict: "E",

			// This creates a local 'data' variable taken from the 'data' attribute in directive declaration.
			scope: {data: "="},

			// Where the magic happens (the directive itself)
			link: function (scope, element, attrs) {


				// Compute some margin and stuff from directive declaration, or use default ones.
				var margin = parseInt(attrs.margin) || 25;

				// Browser onresize event
				window.onresize = function () {
					scope.$apply();
				};

				// Watch for resize event
				scope.$watch(function () {
					return angular.element($window)[0].innerWidth;
				}, function () {
					scope.render(scope.data);
				});

				// Watch for data to be loaded
				scope.$watch("data", function () {
					scope.render(scope.data);
				});

				// the actual render function
				scope.render = function (data) {

					// remove all previous svg items before render
					d3.selectAll("svg").remove();

					// If we don't pass any data, return out of the element
					if (!data) return;

					// compute max data from stats. Used to compute chart height and to draw y axis
					var maxData = d3.max(data, function (d) {
						return d3.max(d.stats, function (d) {
							return d.statValue;
						});
					});

					/*
                    compute width. Commented line below works ok in Chrome. In FF, the svg element just created doesn't take its parent
                     width, so width calculus ends to 0. So we have to take not on ly is parent (same result), but grand parent.
                     */
					//
					//                    var width = d3.select(element[0]).append('svg').node().offsetWidth,
					var width = d3.select(element[0]).append("svg").node().parentNode.parentNode.offsetWidth,

						// compute the height
						height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) / 2;


					// Generate colors automatically.
					var color = d3.scale.category20();

					// scale x axis : groups of stats
					var x0 = d3.scale.ordinal().rangeRoundBands([0, width], .1);

					// scale x axis : stats itself
					var x1 = d3.scale.ordinal();

					// scale y axis (specify height first in range, cos svg is drawn from top left corner => the other way it would draw inverted bars)
					var y = d3.scale.linear().range([height, 0]);

					// define x axis
					var xAxis = d3.svg.axis()
						.scale(x0)
						.orient("bottom");

					// define y axis
					var yAxis = d3.svg.axis()
						.scale(y)
						.orient("left")
						.tickFormat(d3.format(".2s"));

					// draw SVG main element and append a "g". Translate a bit according to margins.
					var svg = d3.select("svg")
						.attr("width", width)
						.attr("height", height + 200)
						.append("g")
						.attr("transform", "translate(" + margin + "," + margin + ")");


					// This array will list stats type. Each stat type is unique (e.g. : ["montée", "descente"]
					var statsTypes = [];
					data.forEach(function (d) {
						d.stats.forEach(function (stat) {
							var found = false;
							statsTypes.forEach(function (type) {
								if (type === stat.statName) {
									found = true;
									return;
								}
							});

							// For "uniqueness"
							if (!found) {
								statsTypes.push(stat.statName);
							}
						});
					});

					// x axis : Compute groups domain
					x0.domain(data.map(function (d) {
						return d.stopPoint;
					}));

					// x axis : compute each stat domain.
					x1.domain(statsTypes).rangeRoundBands([0, x0.rangeBand()]);

					// y axis : compute domain.
					y.domain([0, maxData]);

					// Draw x axis
					svg.append("g")
						.attr("class", "x axis")
						.attr("transform", "translate(0," + height + ")")
						.call(xAxis)
						.selectAll("text")
						.style("text-anchor", "end")
						.attr("dx", "-.8em")
						.attr("dy", ".15em")
						.attr("transform", function (d) {
							return "rotate(-65)";
						});


					// draw groups on x axis
					var graph = svg.selectAll(".graph")
						.data(data)
						.enter().append("g")
						.attr("class", "g")
						.attr("transform", function (d) {
							return "translate(" + x0(d.stopPoint) + ",0)";
						});


					var tooltip = d3.select("svg").append("div")
						.attr("class", "tooltip")
						.style("opacity", 0);

					// draw bars
					graph.selectAll("rect")
						.data(function (d) {
							return d.stats;
						})
						.enter().append("rect")
						.attr("width", x1.rangeBand() )
						.attr("x", function (d) {
							return x1(d.statName);
						})
						.attr("y", height)
						.style("fill", function (d) {
							return color(d.statName);
						})
						.attr("height", 0)

					// FIXME : popup on mouse over ?
						.on("mouseover", function(d) {
							tooltip.transition().duration(200).style("opacity", .9);
							tooltip.html("<span>" + d.statName + ":" + d.statValue + "</span>")
								.style("left", d3.select(this).attr("cx") + "px")
								.style("top", d3.select(this).attr("cy") + "px");

						})
						.on("mouseout", function(d) {
							tooltip.transition().duration(500).style("opacity", 0);
						})

					// smooth animation
						.transition()
						.delay(500)
						.attr("height", function (d) {
							return height - y(d.statValue);
						})
						.attr("y", function (d) {
							return y(d.statValue);
						})
						.duration(1000);



					// Draw Y axis and label it
					// TODO : make this label a directive attribute
					svg.append("g")
						.attr("class", "y axis")
						.call(yAxis)
						.append("text")
						.attr("transform", "rotate(-90)")
						.attr("y", 6)
						.attr("dy", ".71em")
						.style("text-anchor", "end")
						.text("Nombre de passagers");


					// draw horizontal grid lines
					graph.selectAll("line.horizontalGrid").data(y.ticks()).enter()
						.append("line")
						.attr(
							{
								"stroke": "#AAAAAA"
							})
						.transition()
						.delay(1000)
						.duration(1000)
						.attr(
							{
								"class": "horizontalGrid",
								"x1": margin.right,
								"x2": width,
								"y1": function (d) {
									return y(d);
								},
								"y2": function (d) {
									return y(d);
								},
								"fill": "none",
								"shape-rendering": "crispEdges",
								"stroke": "#DDDDDD",
								"stroke-width": "1px"
							});


					// well, legend
					var legend = svg.selectAll(".legend")
						.data(statsTypes.slice().reverse())
						.enter().append("g")
						.attr("class", "legend")
						.attr("transform", function (d, i) {
							return "translate(-50," + i * 20 + ")";
						});

					legend.append("rect")
						.attr("x", width - 18)
						.attr("width", 18)
						.attr("height", 18)
						.style("fill", color);

					legend.append("text")
						.attr("x", width - 24)
						.attr("y", 9)
						.attr("dy", ".35em")
						.style("text-anchor", "end")
						.text(function (d) {
							return d;
						});


				};


			}};


	}]
	);
